import React from "react";
import './Alert.css'
export default function Alert(props) {
  return (
    // <div className={`alert alert-success`} role="alert">
    //   This is a success message.
    // </div>
    props.alert && <div className={`alert alert-${props.alert.type} fixed-alert text-center`} role="alert" >
      {props.alert.msg}
    </div>
  );
}
